/* globals Store */
import api from './backend-api'

export default {
  login (authcode, path, cb) {
    let data = 'auth=' + authcode
    api.login(path, data).then((res) => {
      if (res.token || res.data.token){
        const token = res.token || res.data.token
        const userid = res.id || res.data.id
        const nickname = res.nickname || res.data.nickname
        const user = {"user_id": userid, "nickName": nickname, "email": "admin@test.com", "password": "password"};
        Store.dispatch('user/updateUser', {user, token})
        document.cookie = "nickname=" + nickname + '; Path=/; Expires=Thu, 01 Jan 2070 00:00:01 GMT;';
        document.cookie = "userid=" + userid + '; Path=/; Expires=Thu, 01 Jan 2070 00:00:01 GMT;';
        document.cookie = "token=" + token + '; Path=/; Expires=Thu, 01 Jan 2070 00:00:01 GMT;';
        if (cb) cb(true, null);
      }
    }, (err) => {
      console.log(err)
      if (cb) cb(false, err);
    })
  },

  link (linkcode, cb) {
    cb = arguments[arguments.length - 1]
//    let data = 'username=' + email + '&password=' + pass
    let data = 'link=' + linkcode
    api.login('auth/set-link', data).then((res) => {
 //     console.log(JSON.stringify(res))
      if (res.token || res.data.token){
        const token = res.token || res.data.token
        const userid = res.user_id || res.data.user_id
        const user = {"user_id": userid, "lastName": "", "email": "admin@test.com", "password": "password"};
        Store.dispatch('user/updateUser', {user, token})
        if (cb) cb(true, null)
        this.onChange(true)
      }
    }, (err) => {
      console.log(err)
      if (cb) cb(false, err)
      this.onChange(false)
    })
  },
  getToken () {
    return Store.state.user.token
  },
  logout (cb) {
    // delete localStorage.token
    // Store.commit('setToken', null)
    document.cookie = 'token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    Store.dispatch('user/logout')
    if (cb) cb(false);
//    this.onChange(false)
  },
  loggedIn () {
    const cookiestring = RegExp("token=[^;]+").exec(document.cookie);
    const token = decodeURIComponent(cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");

    return  token !== ''
//    return !!Store.state.user.token
  },
  onChange () {}
}



// WEBPACK FOOTER //
// ./src/utils/auth.js